import { newUi } from "./featureFlags";

/**
 * Issue #819 (D39, Andreas, 2026-09-24, wizard) — one place decides what
 * the seven "My Players" sites (Dashboard.jsx, CoachDrillBankPanel.jsx,
 * CoachPlayerRecord.jsx, LearningHub.jsx) call the coach's roster.
 * `coach-portal-empty` off: byte-for-byte "My Players", same as main.
 * `coach-portal-empty` on: "Your players" (the name #818 gave the coach
 * nav pill, Layout.jsx:146).
 *
 * D183 (Andreas, 2026-09-30, issue #950): admins follow this too — the
 * drill bank and friends call this function for an admin caller exactly
 * as they do for a coach (`isCoachOrAdmin`), and `Layout.jsx`'s
 * `getNavForRole` now relabels `ADMIN_NAV`'s `/coach-portal` entry the
 * same way it already relabels the coach's. This function itself has no
 * role input and does not change for D183 — it never needed one.
 *
 * Call this at RENDER time, never at module scope — a module-level array
 * (Dashboard.jsx's COACH_NAV_CARDS) reads the flag once at import if the
 * label is baked in there instead of mapped where the array is rendered.
 * `coachPlayersNameCallSites.test.js` guards this with an AST scan.
 */
export function coachPlayersName() {
  return newUi("coach-portal-empty") ? "Your players" : "My Players";
}
